import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {
    MainFilterScreen, 
    Breinwaarde, 
    DidactischPrincipe, 
    AantalStudenten, 
    DuurLes, 
    DuurVoorbereiding, 
    KennisVak,
    FilterResultScreen,
    MethodCardScreen
} from './filter_windows';
import Favorites from './Favorites';
import ResetFilterWindow from './parts/ResetFilterWindow';

class App extends Component {
    render() {
        return (
            <div>
                <BrowserRouter>
                    <div>
                        <Switch>
                            <Route exact path="/" component={MainFilterScreen} />
                            <Route path="/favorieten" component={Favorites} />
                            <Route path="/breinwaarde" component={Breinwaarde} />
                            <Route path="/didactisch-principe" component={DidactischPrincipe} />
                            <Route path="/aantal-studenten" component={AantalStudenten} />
                            <Route path="/duur-les" component={DuurLes} />
                            <Route path="/duur-voorbereiding" component={DuurVoorbereiding} />
                            <Route path="/kennis-of-vaardigheidsvak" component={KennisVak} />
                            <Route path="/resultaten" component={FilterResultScreen} />
                            <Route path="/methodekaart" component={MethodCardScreen} />
                            <Route render={() => <h1>Pagina niet gevonden!</h1>} />
                        </Switch>
                    </div>
                </BrowserRouter>
                <ResetFilterWindow />
            </div>
        );
    }
}

export default App;
